// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DTADetailsStatusHistoryInner
 */
export interface DTADetailsStatusHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof DTADetailsStatusHistoryInner
     */
    changed_at: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsStatusHistoryInner
     */
    changed_by: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsStatusHistoryInner
     */
    from_status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsStatusHistoryInner
     */
    history_id: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsStatusHistoryInner
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsStatusHistoryInner
     */
    to_status: string;
    /**
     * DTA version this history entry applies to
     * @type {string}
     * @memberof DTADetailsStatusHistoryInner
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsStatusHistoryInner
     */
    workflow_stage: string;
}

/**
 * Check if a given object implements the DTADetailsStatusHistoryInner interface.
 */
export function instanceOfDTADetailsStatusHistoryInner(value: object): value is DTADetailsStatusHistoryInner {
    if (!('changed_at' in value) || value['changed_at'] === undefined) return false;
    if (!('changed_by' in value) || value['changed_by'] === undefined) return false;
    if (!('history_id' in value) || value['history_id'] === undefined) return false;
    if (!('to_status' in value) || value['to_status'] === undefined) return false;
    if (!('workflow_stage' in value) || value['workflow_stage'] === undefined) return false;
    return true;
}

export function DTADetailsStatusHistoryInnerFromJSON(json: any): DTADetailsStatusHistoryInner {
    return DTADetailsStatusHistoryInnerFromJSONTyped(json, false);
}

export function DTADetailsStatusHistoryInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADetailsStatusHistoryInner {
    if (json == null) {
        return json;
    }
    return {
        
        'changed_at': json['changed_at'],
        'changed_by': json['changed_by'],
        'from_status': json['from_status'] == null ? undefined : json['from_status'],
        'history_id': json['history_id'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'to_status': json['to_status'],
        'version': json['version'] == null ? undefined : json['version'],
        'workflow_stage': json['workflow_stage'],
    };
}

export function DTADetailsStatusHistoryInnerToJSON(json: any): DTADetailsStatusHistoryInner {
    return DTADetailsStatusHistoryInnerToJSONTyped(json, false);
}

export function DTADetailsStatusHistoryInnerToJSONTyped(value?: DTADetailsStatusHistoryInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changed_at': value['changed_at'],
        'changed_by': value['changed_by'],
        'from_status': value['from_status'],
        'history_id': value['history_id'],
        'reason': value['reason'],
        'to_status': value['to_status'],
        'version': value['version'],
        'workflow_stage': value['workflow_stage'],
    };
}
